import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const reactPlugin = new ReactPlugin();

const APP_INSIGHTS_CONN_STRING = process.env.REACT_APP_INSIGHTS_CONN_STRING ?? '';

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: APP_INSIGHTS_CONN_STRING,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false,
    correlationHeaderExcludedDomains: [
      '*.queue.core.windows.net',
      '*.b-cdn.net',
      '*.clearbit.com',
      '*.reddit.com',
      '*.linkedin.com',
      '*.redditstatic.com',
      'sgtm.shoutt.co',
      '*.hotjar.io',
      '*.googleadservices.com',
      '*.google.com',
      '*.google.co.uk',
      '*.tiktok.com',
      '*.facebook.com',
      '*.cookieyes.com',
      'cdn-cookieyes.com',
    ],
    extensions: [reactPlugin],
  },
});
appInsights.loadAppInsights();
